var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCateWork(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 7,
    fill: "#DBEAFE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.59375 6.25986H11.4062C11.4922 6.25986 11.5625 6.32736 11.5625 6.40986V7.15986H8.4375V6.40986C8.4375 6.32736 8.50781 6.25986 8.59375 6.25986ZM7.5 6.40986V7.15986H6.25C5.56055 7.15986 5 7.69799 5 8.35986V10.1599H8.75H11.25H15V8.35986C15 7.69799 14.4395 7.15986 13.75 7.15986H12.5V6.40986C12.5 5.83049 12.0098 5.35986 11.4062 5.35986H8.59375C7.99023 5.35986 7.5 5.83049 7.5 6.40986ZM15 10.7599H11.25V11.3599C11.25 11.6917 10.9707 11.9599 10.625 11.9599H9.375C9.0293 11.9599 8.75 11.6917 8.75 11.3599V10.7599H5V13.1599C5 13.8217 5.56055 14.3599 6.25 14.3599H13.75C14.4395 14.3599 15 13.8217 15 13.1599V10.7599Z",
    fill: "#3B82F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCateWork);
export default __webpack_public_path__ + "static/media/icon-cate-work.4ac8a89a7bf211a9c6c8ee431e98b570.svg";
export { ForwardRef as ReactComponent };